import ColorField from './ColorField';
export default ColorField;
//# sourceMappingURL=index.js.map